// @flow

import type {
  EventAction,
  EventActionCreator,
  EventHandler,
} from 'redux/middleware/googleTagManager/types';
import type {Page} from 'types';

import {config} from 'config';
import {TRAVEL_TYPE_OWN_ARRIVAL, TRAVEL_TYPE_PACKAGE_TOUR} from 'consts';
import {EVENT_PAGE_VIEW} from 'redux/middleware/googleTagManager/actionTypes';
import {GTM_EVENT_PAGE_VIEW} from 'redux/middleware/googleTagManager/eventNames';
import {buildVirtPath} from 'redux/middleware/googleTagManager/utils/virtPath';
import {getJourney} from 'redux/v1/journey/reducer';


type Payload = {
  page: Page,
  pageLoad?: boolean,
};

type Action = EventAction<Payload>;

type Event = {
  virtpath: string,
  event: string,
  event_action: string,
};

const travelTypesMap = {
  '0': 'undefined',
  '653': TRAVEL_TYPE_OWN_ARRIVAL,
  '654': TRAVEL_TYPE_PACKAGE_TOUR,
};

export const action: EventActionCreator<Action, Payload> = (payload) => ({
  type: EVENT_PAGE_VIEW,
  payload,
});

export const handler: EventHandler<Action, Event> = (action, state) => {
  const journeyPort = getJourney(state)?.port || 0;
  const travelType = travelTypesMap[`${journeyPort}`];

  return {
    virtpath: buildVirtPath({
      agent: config.agent,
      page: action.payload.page,
      travelType,
      pageLoad: action.payload.pageLoad,
    }),
    event: GTM_EVENT_PAGE_VIEW,
    event_action: 'spa_pageview',
  };
};
